import { render, staticRenderFns } from "./DebtYears.vue?vue&type=template&id=6489dc98&scoped=true"
import script from "./DebtYears.vue?vue&type=script&lang=js"
export * from "./DebtYears.vue?vue&type=script&lang=js"
import style0 from "./DebtYears.vue?vue&type=style&index=0&id=6489dc98&prod&lang=css"
import style1 from "./DebtYears.vue?vue&type=style&index=1&id=6489dc98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6489dc98",
  null
  
)

export default component.exports